export var sizes = {
  large: 'large',
  normal: 'normal',
  small: 'small'
};
export var sizesList = [sizes.large, sizes.normal, sizes.small];